import { CashbackTransaction } from "../../interfaces"
import { DatePicker, Input } from "@fullscreendigital/carrefour-dex-fe"
import React from "react"
import dayjs from "dayjs"

export const toTableRowItems = (list: CashbackTransaction[]) =>
  list.map(t => ({
    ...t,
    totalPriceLabel: `${Number(t.totalPrice ?? 0).toFixed(2)} RON`,
    discountLabel: `${Number(t.discount ?? 0).toFixed(2)} RON`,
    excludedPriceLabel: `${Number(t.excludedPrice ?? 0).toFixed(2)} RON`,
  }))

export const columns = () => [
  { title: "Data", field: "dateKey", align: "left", type: "string", width: "110px" },
  { title: "Mag.", field: "storeNo", align: "left", type: "string", width: "70px" },
  { title: "POS", field: "workstationId", align: "left", type: "string", width: "70px" },
  { title: "Seq.", field: "transactionSequenceNo", align: "left", type: "string", width: "90px" },
  { title: "Total", field: "totalPriceLabel", align: "right", type: "string", disableSorting: true, width: "110px" },
  { title: "Discount", field: "discountLabel", align: "right", type: "string", disableSorting: true, width: "110px" },
  { title: "Exclus", field: "excludedPriceLabel", align: "right", type: "string", disableSorting: true, width: "110px" },
  { title: "Tip", field: "itemType", align: "left", type: "string", disableSorting: true, width: "110px" },
]

export const toolbarActions = ({ onRefresh, isLoading }: { onRefresh: () => void; isLoading: boolean }) => [
  { label: isLoading ? "Se încarcă..." : "Refresh", onClick: onRefresh, disabled: isLoading },
]

export const filters = () => [
  {
    name: 'dateKey',
    value: '',
    filter: (
      <DatePicker
        label="Selecteaza data"
        variant="outlined"
        value={dayjs()}
        onChange={() => {}}
        adapterLocale="ro"
        modalLabel="Selecteaza data"
        closeButtonLabel="Anuleaza"
        confirmButtonLabel="Confirma"
      />
    ),
    type: 'date',
    label: 'Data'
  },
  {
    name: 'storeNo',
    value: '',
    filter: <Input variant="outlined" label="Mag." type="text" />,
    type: 'text',
    label: 'Mag.'
  },
  {
    name: 'workstationId',
    value: '',
    filter: <Input variant="outlined" label="POS" type="text" />,
    type: 'text',
    label: 'POS'
  },
  {
    name: 'transactionSequenceNo',
    value: '',
    filter: <Input variant="outlined" label="Seq." type="text" />,
    type: 'text',
    label: 'Seq.'
  }
]
